import { render } from "./IncidentsForAdmin.vue?vue&type=template&id=780dd374&scoped=true"
import script from "./IncidentsForAdmin.vue?vue&type=script&lang=js"
export * from "./IncidentsForAdmin.vue?vue&type=script&lang=js"

import "./IncidentsForAdmin.vue?vue&type=style&index=0&id=780dd374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780dd374"]])

export default __exports__